import api from '../../plugins/api';

const getClientUploadStatus = ({ dealId }) => {
  return api.get('/api/crm/clientUpload/status', { params: { dealId } });
};

export default getClientUploadStatus;
